import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  Notification,
  NotificationComponent,
} from '../notification/notification.component';
import { LoadingService } from '../services/loading.service';
import { DataService } from '../services/data.service';
import { FilterCriteriaService, FilterCriteriaRequest } from '../services/filter-criteria.service';
import { SharedService } from '../services/shared.service';

@Component({
  selector: 'app-pagelayout',
  imports: [
    CommonModule,
    TranslateModule,
    NotificationComponent,
      ],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './pagelayout.component.html',
  styleUrl: './pagelayout.component.scss',
})
export class PagelayoutComponent {

  notification!: Notification;
  currentCIStatus: string = '';
  currentCISubstatus: string = '';
  isRolloutStarted: boolean = false;
  openSavedChangesModal: boolean = false;
  isPublishButtonDisabled: boolean = true;
  approvalCheckInProgress: boolean = false;
  rolloutNotificationText: string = '';

  constructor(
    private router: Router,
    public loadingService: LoadingService,
    public dataService: DataService,
    private filterCriteriaService: FilterCriteriaService,
    private sharedService: SharedService,
  ) { }

  onBackClick() {
    this.sharedService.triggerAutoSave().then((success) => {
      this.sharedService.resetTestRun();
    });
  }

  saveFilterCriteria(): Promise<boolean> {
    return new Promise((resolve) => {
      try {
        const filterPayload = this.sharedService.latestPayload;
        const projectId = this.dataService.projectId;

        if (!projectId) {
          console.error('Project ID is required to save filter criteria');
          this.notification = {
            label: 'Error',
            description: 'Project ID is required to save filter criteria',
            type: 'error',
          };
          resolve(false);
          return;
        }

        if (!filterPayload) {
          console.error('No filter criteria to save');
          this.notification = {
            label: 'Error',
            description: 'No filter criteria to save',
            type: 'error',
          };
          resolve(false);
          return;
        }

        const filterFormData = this.sharedService.getFilterFormData();

        const request: FilterCriteriaRequest = {
          projectId: projectId,
          bl: '',
          commonTemplate: filterFormData.commonTemplate || '',
          comments: filterFormData.notes || '', // Notes from filter criteria form
          rootGroup: JSON.stringify(filterPayload.rootGroup)
        };

        this.filterCriteriaService.saveFilterCriteria(request).subscribe({
          next: (response) => {
            console.log('Filter criteria saved successfully:', response);
            this.notification = {
              label: 'Success',
              description: 'Filter criteria saved successfully',
              type: 'success',
            };
            resolve(true);
          },
          error: (error) => {
            console.error('Error saving filter criteria:', error);
            this.notification = {
              label: 'Error',
              description: 'Failed to save filter criteria',
              type: 'error',
            };
            resolve(false);
          }
        });
      } catch (error) {
        console.error('Error preparing filter criteria payload:', error);
        this.notification = {
          label: 'Error',
          description: 'Error preparing filter criteria',
          type: 'error',
        };
        resolve(false);
      }
    });
  }

  onSaveDraftClick(isHomeClick: boolean = false) {
    this.handleFilterCriteriaStepOnSaveDraft(isHomeClick);
    
  }

  onSaveChanges() {
    this.onSaveDraftClick(true);
  }

  handleFilterCriteriaStepOnSaveDraft(isHomeClick: boolean) {
    this.sharedService.triggerAutoSave().then((success) => {
      if (success) {
        this.notification = {
          label: 'Success',
          description: 'Filter criteria draft saved successfully!',
          type: 'success'
        };
        if (isHomeClick) {
          this.moveHome();
        }
      } else {
        this.notification = {
          label: 'Info',
          description: 'No changes to save or save operation skipped.',
          type: 'info'
        };
        this.openSavedChangesModal = false;
      }
    });
  }

  resetSelectedProject() {
    this.sharedService.resetTestRun();
  }

  moveHome() {
    this.openSavedChangesModal = false;
    this.router.navigate(['/']);
    this.sharedService.resetTestRun();
  }
}
